import { injectGlobal } from 'styled-components';
import styledNormalize from 'styled-normalize';

injectGlobal`
    ${styledNormalize}

    html,
    body {
        height: 100%;
	    width: 100%;
        box-sizing: border-box;
        z-index: -100;
        font-family: 'Custom', Montserrat, sans-serif;
        font-size: 16px;
        background-color: #000000;
        
        #root {
            height: 100%;
            width: 100%;
        }
        input {
            -webkit-appearance: none;
            border: none;
            -webkit-border-radius: 0;
            border-radius: 0;
        }

        @media (max-width: 550px) {
            font-size: 14px;
        }
    }

    body {
        -webkit-font-smoothing: antialiased;
	    -moz-osx-font-smoothing: grayscale;
    }
`;



// WEBPACK FOOTER //
// ./src/theme/global-style.ts